<img [src]="getUrl()">